import { ESwitch } from '@/types/interface';

/**
 * 打卡营配置
 */
export interface TCardCamp {
  id: string;
  name: string;
  product: string;
  ownerId: number;
  ownerName: string;
  visible: boolean;
  recommendable: boolean;
  administrators: string;
  cover: string;
  info: string;
  index: number;
  batchInfo: TBatchInfo;
}

interface TBatchInfo {
  beforeStartNum: number;
  startNum: number;
  endNum: number;
}

export interface TCardCampBatch {
  id: string;
  cardCampId: string;
  name: string;
  qrCode: string;
  buttonName: string;
  stTime: Date;
  enTime: Date;
  rewardTime: Date;
  earlyStudy: ESwitch;
  administrators: string;
  notice: string;
  state: BatchState;
}

export enum BatchState {
  NOT_START,
  STARTING,
  END,
}
